import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

import { DEFAULT_LOCALE, LOCALES } from './locales'

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localeDetection: true,
  localePrefix: 'never'
})

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
